<template>
  <f7-page name="uv-index" @page:init="onPageInit">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>UV Index</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <template v-if="dailyDataLoaded">

      <f7-toolbar tabbar bottom>
        <f7-link tab-link="#uv-tab-1" tab-link-active>Priebeh</f7-link>
        <f7-link tab-link="#uv-tab-2">Predpoveď</f7-link>
      </f7-toolbar>
      <f7-tabs>
        <f7-tab id="uv-tab-1" tab-active>
          <template v-if="isStationsLoaded">
            <f7-list class="ss-list">
              <f7-list-item title="Stanica:"
                            class="uv-ss-list"
                            smart-select
                            :smart-select-params="{openIn: 'popup', scrollToSelectedItem:true, closeOnSelect: true, pageTitle:'Vyberte stanicu', popupCloseLinkText:'Návrat', searchbar: {  removeDiacritics:true, customSearch: true, on: { search: searchFromBeginning }, }, searchbarPlaceholder: 'Hľadať...'}">
                <select name="station" v-model="selectedStationId">
                  <option v-for="option in UVIndexStations" v-bind:value="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </f7-list-item>
              <f7-list-input
                  label="Dátum merania"
                  type="datepicker"
                  placeholder="Vyberte dátum"
                  readonly
                  @calendar:change="onDtChange"
                  :value="selectedDaylyDtF"
                  :calendar-params="{locale: 'sk-SK', dateFormat: 'dd.mm.yyyy', closeOnSelect:true, minDate: minDtF, maxDate: maxDtF}"
              ></f7-list-input>
            </f7-list>
            <template v-if="dailyData.length && !isError">
              <highcharts ref="uvDailyHighcharts" :updateArgs="[true, true, true]" :options="chartOptions"></highcharts>
            </template>

            <f7-block>
              <UVIndexLegenda />
            </f7-block>
          </template>
        </f7-tab>
        <f7-tab id="uv-tab-2" >
          <f7-block class="mt-1">
            <template v-if="isForecastDataLoaded">
              <template v-if="uvidata.data.length > 0">
                <strong>
                  Predpoveď UV indexu pre nízke a stredné polohy na:
                </strong>
                <table class="no-border uvi-top-border center w-100">
                  <template v-for="item in uvidata.data">
                    <tr>
                      <td class="text-align-right py-1"><strong>poludnie dňa {{ item.dt_predpoved | moment('DD.MM.YYYY') }}:</strong></td>
                      <td :class="'px-1 ' + 'bg-uvi-'+getUVIBg(item.uvindex_predpoved_poludnie)">{{ item.uvindex_predpoved_poludnie }}</td>
                    </tr>
                  </template>
                </table>
              </template>

              <f7-block class="no-padding">
                <f7-list class="no-margin">
                  <f7-list-item title="Predpoveď na:" smart-select :smart-select-params="{openIn: 'popover', searchbar: false, popupCloseLinkText:'Zavrieť', closeOnSelect:true}">
                    <select v-model="selectedDate">
                      <option v-for="option in availDates" v-bind:value="option">
                        {{ option | moment('DD.MM.YYYY') }}
                      </option>
                    </select>
                  </f7-list-item>
                </f7-list>

              </f7-block>

              <f7-block class="no-padding">
                <template v-if="notEmptyObject(dataDennyChod)" >
                  <div class="text-align-center">Predpoveď denného chodu UV indexu na {{ selectedDate | moment('DD.MM.YYYY') }}</div>
                  <highcharts ref="uvDennyChodHighcharts" :updateArgs="[true, true, true]" :options="chartOptionsDennyChod"></highcharts>
                </template>
                <template v-if="notEmptyObject(dataZavislost)" >
                  <div class="text-align-center">Závislosť UV indexu na poludnie od nadmorskej výšky počas dňa {{ selectedDate | moment('DD.MM.YYYY') }}</div>
                  <highcharts ref="uvZavislostHighcharts" :updateArgs="[true, true, true]" :options="chartOptionsZavislost"></highcharts>
                </template>
              </f7-block>

              <UVIndexLegenda />

            </template>
            <template v-else>
              <div class="alert-error">{{ errorMsgForecast }}</div>
            </template>


          </f7-block>
        </f7-tab>

      </f7-tabs>



    </template>
  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";
import PinchZoom from 'vue-pinch-zoom';
import {Chart} from 'highcharts-vue'
import Highcharts from 'highcharts';
import searchMixin from "../js/mixin";

require('highcharts/modules/pattern-fill')(Highcharts);


import UVIndexDennyChodChart from './UVIndexDennyChod-chart-options'
import UVIndexZavislostChart from './UVIndexZavislost-chart-options'
import UVIndexDailyChart from './UVIndexDaily-chart-options'
import UVIndexLegenda from './uv-index-legenda'


Highcharts.setOptions({
  lang: {
    weekdays: ['Nedeľa','Pondelok', 'Utorok', 'Streda', 'Štvrtok', 'Piatok', 'Sobota'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
    months: ['Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún', 'Júl', 'August', 'September', 'Október', 'November', 'December']
  },
  global: {
    useUTC: false,
  }
});

export default {
  components: {
    highcharts: Chart,
    UVIndexLegenda: UVIndexLegenda
  },
  mixins: [searchMixin],
  data: function () {
    return {
      dt_f: null,
      dt: null,
      uvidata: {},
      prevDisabled: false,
      nextDisabled: false,
      isError: false,
      errorMsg: null,
      errorMsgForecast: null,
      errorMsgDaily: null,
      isDataLoaded: false,
      isForecastDataLoaded: false,
      isLoading: true,
      selectedDate: null,
      availDates: [],
      lang: 'sk',
      imgDennyChod : null,
      imgZavislost : null,
      dataDennyChod : {},
      dataZavislost : {},
      chartOptionsDennyChod: UVIndexDennyChodChart,
      chartOptionsZavislost: UVIndexZavislostChart,

      minDt: 1577833200 * 1000, // 2020-01-01
      maxDt: null,
      dailyDataLoaded: false,
      latestDailyDataLoadedCombo: null,
      dailyData: [],
      stations: [],
      UVIndexStations: [],
      isStationsLoaded: false,
      selectedStationId: null,
      defaultStationId: 11813,
      defaultStationName: null,
      selectedStationName: null,
      chartOptions: UVIndexDailyChart,
      stationDataForChart: {},
      selectedDaylyDt: null,
    };
  },
  watch: {
    uvidata() {
      this.availDates = [];
      if (this.uvidata.data.length > 0) {
        this.uvidata.data.forEach((item, idx) => {
          if (this.availDates.indexOf(item.dt_predpoved) === -1) {
            this.availDates.push(item.dt_predpoved);
          }
        });

        this.availDates.sort();
        this.selectedDate = this.availDates[0];
      }
    },
    selectedDate() {
      // vyber zaznamy s lang a selectedData
      let filtered = this.uvidata.data.filter(item => (item.dt_predpoved === this.selectedDate));
      this.dataDennyChod = {};
      this.dataZavislost = {};
      if (filtered.length > 0) {
        if (filtered[0].uvindex_predpoved_den) {
          this.dataDennyChod = filtered[0].uvindex_predpoved_den;
        }
        if (filtered[0].uvindex_predpoved_zavislost) {
          this.dataZavislost = filtered[0].uvindex_predpoved_zavislost;
        }

        if (Object.keys(this.dataDennyChod).length) {
          this.chartOptionsDennyChod.xAxis.categories = this.dataDennyChod.header;

          let m1 = this.chartOptionsDennyChod.series.find(item => (item.id) === 'uv-jasno');
          if (m1) {
            m1.data = this.dataDennyChod.jasno;
          }
          let m2 = this.chartOptionsDennyChod.series.find(item => (item.id) === 'uv-polooblacno');
          if (m2) {
            m2.data = this.dataDennyChod.polooblacno;
          }
          let m3 = this.chartOptionsDennyChod.series.find(item => (item.id) === 'uv-oblacno');
          if (m3) {
            m3.data = this.dataDennyChod.oblacno;
          }
        }

        if (Object.keys(this.dataZavislost).length) {
          this.chartOptionsZavislost.xAxis.categories = this.dataZavislost.header;

          let m1 = this.chartOptionsZavislost.series.find(item => (item.id) === 'uvz-jasno');
          if (m1) {
            m1.data = this.dataZavislost.jasno;
          }
          let m2 = this.chartOptionsZavislost.series.find(item => (item.id) === 'uvz-polooblacno');
          if (m2) {
            m2.data = this.dataZavislost.polooblacno;
          }
          let m3 = this.chartOptionsZavislost.series.find(item => (item.id) === 'uvz-oblacno');
          if (m3) {
            m3.data = this.dataZavislost.oblacno;
          }
        }


      }

      let index = this.availDates.indexOf(this.selectedDate);
      let maxIndex = this.availDates.length - 1;
      // ak je prvy, blokujeme prev a povolujeme next
      if (index === 0) {
        this.prevDisabled = true;
        this.nextDisabled = false;
      }

      // ak nie je aktualny prvy, povolujeme prev
      if (index > 0) {
        this.prevDisabled = false;
      }

      // ak je aktualny posledny, blokujeme next
      if (index === maxIndex) {
        this.nextDisabled = true;
      }

      // je tam len jeden prvok, blokujeme oba
      if (index === 0 && index === maxIndex ) {
        this.nextDisabled = true;
        this.prevDisabled = true;
      }




    },
    selectedDaylyDt(v) {
      if (this.selectedStationId && this.isStationsLoaded) {
        this.getDailyData(false);
      }
    },
    stations() {
      if (this.stations.length > 0) {
        this.stations.forEach(v => {
          if (v.id_station === this.defaultStationId) {
            this.defaultStationName = v.station_name;
          }
          this.UVIndexStations.push({
            value: v.id_station,
            text: v.station_name
          });
        });
      }
    },
    selectedStationId() {
      if (this.selectedStationId && this.isStationsLoaded) {
        //console.log('get data from selectedStationId');
        this.getDailyData(true);
        this.$ls.set('uvindex_selected_station_id', this.selectedStationId, 365 * 24 * 60 * 60 * 1000); // 1 rok
        let t = this.stations.filter(item => item.id_station === this.selectedStationId);
        if (t) {
          this.selectedStationName = t[0].station_name;
        }
      }
    },
    isStationsLoaded() {
      // console.log('get data from isStationsLoaded');
      // this.getDailyData();
    }


  },
  computed: {
    today_ts: function() {
      let base_today = this.$moment().format('YYYY-MM-DD 00:00');
      return this.$moment(base_today).unix();
    },
    minDtF: function() {
      return this.$moment.unix(this.minDt / 1000).toDate();
    },
    maxDtF: function() {
      const md = this.maxDt;
      return this.$moment.unix(this.maxDt).toDate();
    },
    selectedDaylyDtF: function() {
      return [this.$moment.unix(this.selectedDaylyDt).toDate()];
    }

  },
  mounted() {
    const self = this;

    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-pocasie');
    this.$f7.accordion.open('.shmu-i-pocasie');


  },
  destroy() {
    clearInterval(this.tCheckInterval);
  },
  methods: {
    onPageInit() {
      this.pageReload(null, true);
    },
    updateChartData() {

      // https://codesandbox.io/s/7o37zv74rj

    },
    pageReload(event, isInit) {
      const self = this;

      // this.dt_f = this.$moment.unix(this.maxDt / 1000).toDate()

      if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) { // ak posledne stiahnutie bolo menej ako 1 min, tak nedovolime refresh

        this.getData();
        this.getStations(true);

      }

      if (!isInit && (this.$moment().unix() - this.lastUpdated) > 60) {
        this.getDailyData(true);
      }
    },
    getData() {
      const self = this;
      this.isLoading = true;
      this.errorMsgForecast = null;
      let cached_data = self.$ls.get('uvindex_forecast_data');
      if (cached_data !== null) {
        self.uvidata = cached_data;
        self.lastUpdated = self.$moment().unix();
        this.$nextTick(() => {
          self.isForecastDataLoaded = true;
          self.isLoading = false;
        });
      } else {
        self.$f7.dialog.preloader('Načítavam...');
        Axios.get(SHMUconf.API_BASE_URL + 'uvindex/getforecast', {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                self.uvidata = response.data;
                self.isForecastDataLoaded = true;
                self.$ls.set('uvindex_forecast_data', self.uvidata, 10 * 60 * 1000); // 10 min
                self.lastUpdated = self.$moment().unix();
              } else {
                if (response.data.error[0].text) {
                  this.errorMsgForecast = response.data.error[0].text;
                } else {
                  this.errorMsgForecast = 'Nepodarilo sa načítať informácie o ozóne a UV indexe';
                  self.$f7.dialog.alert(this.errorMsgForecast, 'Nastala chyba');
                }

              }
              self.$f7.dialog.close();

            }).catch((error) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });

      }
    }, // uvi forecast
    prevDay() {
      let index = this.availDates.indexOf(this.selectedDate);
      if (index > 0) {
        this.selectedDate = this.availDates[index - 1];
      }
    }, // uvi forecast
    nextDay() {
      let index = this.availDates.indexOf(this.selectedDate);
      if (index < this.availDates.length - 1) {
        this.selectedDate = this.availDates[index + 1];
      }
    }, // uvi forecast
    getUVIBg(val) {
      if (val <= 2) return 'green';
      if (val <= 5) return 'yellow';
      if (val <= 7) return 'orange';
      if (val > 7) return 'red';
    },

    getStations(load_data) { // uvi denny chod
      const self = this;
      let cached_stations = self.$ls.get('uvindex_stations');
      this.errorMsg = null;
      if (cached_stations !== null) {
        self.stations = cached_stations;
        let cached_selected = this.$ls.get('uvindex_selected_station_id');
        if (cached_selected) {
          self.selectedStationId = cached_selected;
        } else {
          self.selectedStationId = this.defaultStationId;
        }

        this.$nextTick(() => {
          self.isStationsLoaded = true;
        });

        if (load_data) {
          self.getDailyData();
        }
      } else {
        this.isLoading = true;
        self.$f7.dialog.preloader('Načítavam...');
        Axios.get(SHMUconf.API_BASE_URL + 'uvindex/getstations', {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                self.stations = response.data;
                let cached_selected = this.$ls.get('uvindex_selected_station_id');
                if (cached_selected) {
                  self.selectedStationId = cached_selected;
                } else {
                  self.selectedStationId = this.defaultStationId;
                }
                self.isStationsLoaded = true;
                self.$ls.set('uvindex_stations', self.stations, 24 * 60 * 60 * 1000); // 1 den
                //self.getDailyData();
                if (load_data) {
                  self.getDailyData();
                }
              } else {
                this.isError = true;
                if (response.data.error[0].text) {
                  this.errorMsg = response.data.error[0].text;
                } else {
                  this.errorMsg = 'Nepodarilo sa načítať zoznam staníc pre UV Index!';
                }
                self.$f7.dialog.alert(this.errorMsg, 'Nastala chyba');

              }
              self.$f7.dialog.close();
              this.isLoading = false;

            }).catch((error) => {
          this.isError = true;
          this.isLoading = false;
          self.$f7.dialog.close();
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');

        });

      }
    },
    getDailyData(force_load) {
      const self = this;
      this.errorMsgDaily = null;

      if (this.selectedStationId === null) {
        this.selectedStationId = this.defaultStationId;
      }

      if (force_load === false && self.selectedDaylyDt + '-' + self.selectedStationId === self.latestDailyDataLoadedCombo) {
        // console.log('x');
        return;
      }

      this.isLoading = true;
      self.$f7.dialog.preloader('Načítavam...');

      let addon = '';
      if (self.selectedDaylyDt) {
        addon = '&dt=' + self.selectedDaylyDt;
      }

      Axios.get(SHMUconf.API_BASE_URL + 'uvindex/getdailydata?station=' + this.selectedStationId + addon, {
        crossDomain: true,
        cache: false,
      }).then((response) => {
        if (!response.data.error) {
          self.dailyData = response.data;
          // console.log('mam data', response.data)

          if (self.selectedDaylyDt === null && self.dailyData.length) {
            self.selectedDaylyDt = self.dailyData[0].dt_ts;
            self.maxDt = self.dailyData[0].dt_ts;
          }

          self.latestDailyDataLoadedCombo = self.selectedDaylyDt + '-' + this.selectedStationId;

          self.dailyDataLoaded = true;
          self.lastUpdated = self.$moment().unix();
          this.isError = false;
          this.generateChart();

        } else {
          this.isError = true;
          if (response.data.error[0].text) {
            this.errorMsgDaily = response.data.error[0].text;
            self.latestDailyDataLoadedCombo = self.selectedDaylyDt + '-' + this.selectedStationId;
          } else {
            this.errorMsgDaily = 'Nepodarilo sa načítať údaje o priebehu UV Indexu!';
          }
          self.$f7.dialog.alert(this.errorMsgDaily, 'Nastala chyba');

        }
        self.$f7.dialog.close();
        this.isLoading = false;
      }).catch((error) => {
        this.isError = true;
        this.isLoading = false;
        self.$f7.dialog.close();
        self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');

      });

    },
    generateChart() {

      let uvdata = [];

      // priprav data pre chart
      if (this.dailyData.length > 0) {
        this.dailyData.forEach((item) => {
          if (item.value !== null) item.value = parseFloat(item.value);
          uvdata.push([item.dt_ts * 1000, item.value]);
          /*
          // donutenie ho zobrazovat SEC/LSEC casy na grafe
          let m_f = this.$moment.unix(item.dt_ts).tz('Europe/Bratislava').utc().format();
          let m = this.$moment(m_f);
          let d = Date.UTC(m.year(), m.month(), m.date(), m.hours(), m.minutes(), m.seconds());
          uvdata.push([d, item.value]);
           */


        });
      }

      let m1 = this.chartOptions.series.find(item => (item.id) === 'uvDaily');
      m1.data = uvdata;

      this.chartOptions.title.text = 'Priebeh UV Indexu počas dňa ' + this.$moment(this.selectedDaylyDt * 1000).format('DD.MM.YYYY');
      this.chartOptions.subtitle.text = this.selectedStationName;

    },

    onDtChange(val) {

      let val_ts = this.$moment(val[0]).unix();
      if (this.selectedDaylyDt !== val_ts) {
        this.selectedDaylyDt = val_ts;
      }



    }


  }

};
</script>

<style lang="scss">

.bg-uvi-yellow {
  background-color: #FFFF00 !important;
  color: black !important;
  font-weight: bold;
  text-align: center;
  font-size: 16px !important;
}

.bg-uvi-green {
  background-color: #008000 !important;
  color: white !important;
  font-weight: bold;
  text-align: center;
  font-size: 16px !important;
}

.bg-uvi-orange {
  background-color: #FF8C00 !important;
  color: black !important;
  font-weight: bold;
  text-align: center;
  font-size: 16px !important;
}

.bg-uvi-red {
  background-color: #FF0000 !important;
  color: white !important;
  font-weight: bold;
  text-align: center;
  font-size: 16px !important;
}
.uvi-top-border tr:nth-child(2) td {
  border-top: 1px solid #dadada !important;
}


.alert-error {
  border: 2px solid red;
  text-align:center;
  padding: 10px;
  margin: 10px;
  color: red;
  font-weight:bold;
}

</style>
